import { Box, Divider, styled } from '@mui/material';
import { pxToRem } from '@themes';
var StyledScroll = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  return {
    maxHeight: pxToRem(413),
    overflowY: 'auto',
    paddingTop: pxToRem(12)
  };
});
var StyledCheckBoxContainer = styled(Box)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    borderBottom: "".concat(pxToRem(1), " solid ").concat(theme.colors.athensGray),
    '&:last-child': {
      borderBottom: 'unset'
    }
  };
});
var StyledDivider = styled(Divider)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    position: 'absolute',
    left: 0,
    bottom: pxToRem(92),
    width: '100%'
  };
});
export { StyledCheckBoxContainer, StyledDivider, StyledScroll };